export default "__VITE_ASSET__IQoZYXpo__"